/* eslint-disable no-restricted-imports */
/*
 * Utilities for evaluating dates.
 */
import { isValid } from 'date-fns';

import { DateFormat } from './dateFormats';
import { parseDate } from './parseDate';
import { formatDate } from './formatDate';

/**
 * Checks if a given string is a valid ISO date with offset.
 *
 * @param {string} date - The date string to validate.
 * @returns {boolean} True if the string is a valid ISO date with offset, false otherwise.
 */
export function isIsoDateWithOffset(date: string): boolean {
    if (isValid(parseDate(date, DateFormat.API_DATE_WITH_OFFSET, true))) {
        return true;
    }

    return false;
}

/**
 * Checks if a given Date has time set to midnight in bank time zone.
 *
 * @param {Date} date - The date to check - string/Date
 * @returns {boolean} True if the Date has time set to midnight in bank time zone, false otherwise.
 */
export function isMidnightInBankTimezone(date: Date | string): boolean {
    return (
        formatDate(date, DateFormat.HOUR_SINGLE) === '0' &&
        formatDate(date, DateFormat.MINUTE_SINGLE) === '0'
    );
}
